import * as fromDatatype from '../datatype-library';

export interface bl_fi_deposit_requisition_hdr_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    server_doc_type: fromDatatype.VarcharDatatypeInterface;
    server_doc_no: fromDatatype.VarcharDatatypeInterface;
    category_guid: fromDatatype.GuidDataFieldInterface;
    comp_guid: fromDatatype.GuidDataFieldInterface;
    deposit_start_date: fromDatatype.TimestampTzDatatypeInterface;
    maturity_end_date: fromDatatype.TimestampTzDatatypeInterface;
    term: fromDatatype.NumericDatatypeInterface;
    term_type: fromDatatype.VarcharDatatypeInterface;
    currency: fromDatatype.VarcharDatatypeInterface;
    deposit_amount: fromDatatype.NumericDatatypeInterface;
    maturity_amount: fromDatatype.NumericDatatypeInterface;
    interest_type: fromDatatype.VarcharDatatypeInterface;
    interest_calc_period: fromDatatype.VarcharDatatypeInterface;
    interest_calculation_logic: fromDatatype.VarcharDatatypeInterface;
    interest_rate: fromDatatype.NumericDatatypeInterface;
    interest_ref_type: fromDatatype.VarcharDatatypeInterface;
    interest_rate_ref_source: fromDatatype.VarcharDatatypeInterface;
    interest_rate_ref_delta: fromDatatype.NumericDatatypeInterface;
    interest_rate_ref_value: fromDatatype.NumericDatatypeInterface;
    interest_rate_effective: fromDatatype.NumericDatatypeInterface;
    interest_to_principal_logic: fromDatatype.VarcharDatatypeInterface;
    inflation_rate: fromDatatype.NumericDatatypeInterface;
    auto_rollover_logic: fromDatatype.VarcharDatatypeInterface;
    est_interest_amount: fromDatatype.NumericDatatypeInterface;
    actual_interest_amount: fromDatatype.NumericDatatypeInterface;
    gl_code_guid: fromDatatype.GuidDataFieldInterface;
    process_hdr_guid: fromDatatype.GuidDataFieldInterface;
    process_hdr_code: fromDatatype.VarcharDatatypeInterface;
    process_status_guid: fromDatatype.GuidDataFieldInterface;
    process_status: fromDatatype.VarcharDatatypeInterface;
    created_by: fromDatatype.VarcharDatatypeInterface;
    updated_by: fromDatatype.VarcharDatatypeInterface;
    rollover_group_guid: fromDatatype.GuidDataFieldInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    code: fromDatatype.VarcharArrayDatatypeInterface;
    name: fromDatatype.VarcharArrayDatatypeInterface;
    descr: fromDatatype.VarcharArrayDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    namespace: fromDatatype.VarcharArrayDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    comp_code: fromDatatype.VarcharDatatypeInterface;
    category_code: fromDatatype.VarcharDatatypeInterface;
    gl_code_1: fromDatatype.VarcharDatatypeInterface;
    gl_code_2: fromDatatype.VarcharDatatypeInterface;
    gl_code_3: fromDatatype.VarcharDatatypeInterface;
    gl_code_4: fromDatatype.VarcharDatatypeInterface;
    gl_code_name: fromDatatype.VarcharDatatypeInterface;
    entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
    entity_hdr_name: fromDatatype.VarcharDatatypeInterface;
    posting_status: fromDatatype.VarcharDatatypeInterface;
}

export class bl_fi_deposit_requisition_hdr_RowClass implements bl_fi_deposit_requisition_hdr_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    server_doc_type: fromDatatype.VarcharDatatypeInterface;
    server_doc_no: fromDatatype.VarcharDatatypeInterface;
    category_guid: fromDatatype.GuidDataFieldInterface;
    comp_guid: fromDatatype.GuidDataFieldInterface;
    deposit_start_date: fromDatatype.TimestampTzDatatypeInterface;
    maturity_end_date: fromDatatype.TimestampTzDatatypeInterface;
    term: fromDatatype.NumericDatatypeInterface;
    term_type: fromDatatype.VarcharDatatypeInterface;
    currency: fromDatatype.VarcharDatatypeInterface;
    deposit_amount: fromDatatype.NumericDatatypeInterface;
    maturity_amount: fromDatatype.NumericDatatypeInterface;
    interest_type: fromDatatype.VarcharDatatypeInterface;
    interest_calc_period: fromDatatype.VarcharDatatypeInterface;
    interest_calculation_logic: fromDatatype.VarcharDatatypeInterface;
    interest_rate: fromDatatype.NumericDatatypeInterface;
    interest_ref_type: fromDatatype.VarcharDatatypeInterface;
    interest_rate_ref_source: fromDatatype.VarcharDatatypeInterface;
    interest_rate_ref_delta: fromDatatype.NumericDatatypeInterface;
    interest_rate_ref_value: fromDatatype.NumericDatatypeInterface;
    interest_rate_effective: fromDatatype.NumericDatatypeInterface;
    interest_to_principal_logic: fromDatatype.VarcharDatatypeInterface;
    inflation_rate: fromDatatype.NumericDatatypeInterface;
    auto_rollover_logic: fromDatatype.VarcharDatatypeInterface;
    est_interest_amount: fromDatatype.NumericDatatypeInterface;
    actual_interest_amount: fromDatatype.NumericDatatypeInterface;
    gl_code_guid: fromDatatype.GuidDataFieldInterface;
    process_hdr_guid: fromDatatype.GuidDataFieldInterface;
    process_hdr_code: fromDatatype.VarcharDatatypeInterface;
    process_status_guid: fromDatatype.GuidDataFieldInterface;
    process_status: fromDatatype.VarcharDatatypeInterface;
    created_by: fromDatatype.VarcharDatatypeInterface;
    updated_by: fromDatatype.VarcharDatatypeInterface;
    rollover_group_guid: fromDatatype.GuidDataFieldInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    code: fromDatatype.VarcharArrayDatatypeInterface;
    name: fromDatatype.VarcharArrayDatatypeInterface;
    descr: fromDatatype.VarcharArrayDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    namespace: fromDatatype.VarcharArrayDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    comp_code: fromDatatype.VarcharDatatypeInterface;
    category_code: fromDatatype.VarcharDatatypeInterface;
    gl_code_1: fromDatatype.VarcharDatatypeInterface;
    gl_code_2: fromDatatype.VarcharDatatypeInterface;
    gl_code_3: fromDatatype.VarcharDatatypeInterface;
    gl_code_4: fromDatatype.VarcharDatatypeInterface;
    gl_code_name: fromDatatype.VarcharDatatypeInterface;
    entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
    entity_hdr_name: fromDatatype.VarcharDatatypeInterface
    posting_status: fromDatatype.VarcharDatatypeInterface;
}
